import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import {
   getCourseAssignmentIndividualStageSummaries as getCourseAssignmentIndividualStageSummariesFromMonolith,
   IndividualSummaryDetailCourse,
} from '~/monolith-api';
import { CommonRequestOptions } from '~/monolith-api/makeRequest';

export type { IndividualSummaryDetailCourse };

export { isTeamStageCompletionRecord, isUserStageCompletionRecord } from '~/monolith-api';

const getCourseAssignmentIndividualStageSummaryDetailsSchema = z.object({
   userid: z.number().optional(),
});

export async function getCourseAssignmentIndividualStageSummaryDetails(
   userid: number | undefined,
   options: CommonRequestOptions
) {
   if (userid === undefined) return null;
   return await getCourseAssignmentIndividualStageSummariesFromMonolith(userid, options);
}

export default createBFFHandlers({
   post: async (req, res) => {
      const { userid } = getCourseAssignmentIndividualStageSummaryDetailsSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getCourseAssignmentIndividualStageSummaryDetails(userid, {
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const getCourseAssignmentIndividualStageSummaryDetailsFromClient = (
   userid: number | undefined
): ReturnType<typeof getCourseAssignmentIndividualStageSummaryDetails> => {
   return bff()
      .post(`/courses/assignments/getIndividualStageSummaryDetails`, {
         userid,
      })
      .then(response => response.data);
};
